import * as t from "io-ts";

const TextValuePairCodec = t.type({
  Text: t.string,
  Value: t.string
});

const RangeCodec = t.type({
  From: t.string,
  To: t.string,
  Length: t.number,
  Account: t.array(
    t.union([
      t.literal<string>("Cheque"),
      t.literal<string>("Savings"),
      t.literal<string>("Credit"),
      t.literal<string>("Default")
    ])
  )
});

const PromptCodec = t.type({
  Label: t.string,
  Hint: t.string,
  Type: t.union([
    t.literal<string>("AMOUNT"),
    t.literal<string>("NUMBER"),
    t.literal<string>("TEXT"),
    t.literal<string>("OPTIONS")
  ]),
  Condition: t.union([
    t.literal<string>(""),
    t.literal<string>("BP_ODOMETER_REQUIRED"),
    t.literal<string>("BP_VEHICLE_ID_REQUIRED"),
    t.literal<string>("BP_FLEET_ID_REQUIRED"),
    t.literal<string>("OPBP_DRIVER_ID_REQUIREDTIONS"),
  ]),
  MinCharacters: t.union([t.undefined, t.number]),
  MaxCharacters: t.union([t.undefined, t.number]),
  Options: t.array(TextValuePairCodec),
  Tag: t.string,
  Language: t.string
});

const CardPromptBinCodec = t.type({
  Range: t.array(RangeCodec),
  Prompt: t.array(PromptCodec)
});

const AttributesCodec = t.type({
  Name: t.string,
  Bin: t.array(CardPromptBinCodec)
});

const CardPromptCodec = t.type({
  id: t.union([t.undefined, t.string]),
  type: t.string,
  attributes: AttributesCodec
});

export type CardPromptType = t.TypeOf<typeof CardPromptCodec>;
export type CardPromptAttributes = t.TypeOf<typeof AttributesCodec>;
export type CardPromptBinType = t.TypeOf<typeof CardPromptBinCodec>;
export type PromptType = t.TypeOf<typeof PromptCodec>;
export type RangeType = t.TypeOf<typeof RangeCodec>;
export type TextValuePairType = t.TypeOf<typeof TextValuePairCodec>;

export enum CardPromptActionTypes {
  FETCH_ONE = "@@cardPrompt/FETCH_ONE",
  FETCH_MANY = "@@cardPrompt/FETCH_MANY",
  SAVE = "@@CardPrompt/SAVE",
  DELETE = "@@CardPrompt/DELETE"
}
export interface CardPromptState {
  entries: CardPromptType[];
  selected?: CardPromptType;
  loading: boolean;
}
